// Component Recommend/RecommendFree
<template>
  <div class="free-item">
    <free-title :title="data.title" @click.native="toPage(0)"/>

    <ul class="free-item-list"  @click="toPage(1)">
      <li v-for="(item, index) of data.freeColumnOperations" :key="`free${index}`">
        <img class="icon-play" src="../../assets/icons/free_play.svg" alt="play"/>
        <span>{{item.title}}</span>
        <img class="icon-to" src="../../assets/icons/arrow_tiny.svg" alt="toView"/>
      </li>
    </ul>
  </div>
</template>

<script>
  import Title from './FreeTitle'

  export default {
    name: 'recommend-free',

    props: ['data'],

    methods: {
      toPage (flag) {
        this.$router.push(`/super-paper?columnId=${this.data.columnId}`)
      }
    },

    components: {
      FreeTitle: Title
    }
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";

  $global-width: 750;

  .free-item {
    background-color: #fff;
    margin-top: rem(60);
    &-list {
      padding-bottom: rem(35);
      border-radius: rem(8);
      border: rem(1) solid #E6E6E6;
      background-color: #F5F6F8;

      li {
        // @include height(28);
        color: #666;
        font-size: rem(28);
        text-indent: rem(35);
        margin-top: rem(32);

        .icon-play {
          height: rem(37);
          width: rem(37);
          line-height: rem(28);
          vertical-align: middle;
        }

        .icon-to {
          height: rem(12);
          width: rem(6);
          line-height: rem(28);
          vertical-align: middle;
        }

        span {
          display: inline-block;
          width: rem(582);
          line-height: 1.5;
          // line-height: rem(28);
          text-indent: rem(25);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          vertical-align: middle;
        }
      }
    }
  }
</style>
